import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'sonner'
import { AuthProvider } from './contexts/auth-context'
import App from './App.tsx'
import './index.css'

// Single shared query client. React Query collapses concurrent identical
// queries (same queryKey) into one in-flight request, which is what removes the
// duplicate-consumer pairs — e.g. the sidebar is rendered twice (desktop +
// mobile drawer) and each instance requesting the same key now shares one fetch.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <AuthProvider>
        <App />
        <Toaster 
          position="top-right" 
          closeButton
          toastOptions={{
            style: {
              background: 'hsl(0 0% 100%)',
              color: 'hsl(222.2 84% 4.9%)',
              border: '1px solid hsl(214.3 31.8% 91.4%)',
            },
            classNames: {
              error: '!bg-red-500 !text-white !border-red-500 [&>*]:!text-white',
            }
          }}
        />
      </AuthProvider>
    </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
)